import {useNotificationsPoll} from "app/employee/notification/useNotificationsPoll";

export const NotificationPoll = () => {
  useNotificationsPoll();
  return null;
};
